import { useState } from 'react';
import { WizardStep, OnboardingWizardProps } from '@/features/onboarding/types/onboarding.types';
import { WelcomeStep } from './steps/WelcomeStep';
import { SetupPasswordStep } from './steps/SetupPasswordStep';
import { ActivateCardStep } from './steps/ActivateCardStep';
import { SuccessStep } from './steps/SuccessStep';
import styles from './Onboarding.module.css';
import { t } from '@/i18n';


export function OnboardingWizard({ token, user }: OnboardingWizardProps) {
	const [currentStep, setCurrentStep] = useState<WizardStep>(t('onboarding.steps.welcome'));

	const goToPasswordSetup = () => {
		setCurrentStep(t('onboarding.steps.setupPassword'));
	};

	const goToCardActivation = () => {
		setCurrentStep(t('onboarding.steps.activateCard'));
	};

	const goToSuccess = () => {
		setCurrentStep(t('onboarding.steps.success'));
	};

	return (
		<div className={styles.wizardContainer}>
			{currentStep === t('onboarding.steps.welcome') && (
				<WelcomeStep onSuccess={goToPasswordSetup} />
			)}
			{currentStep === t('onboarding.steps.setupPassword') && (
				<SetupPasswordStep token={token} onSuccess={goToCardActivation} />
			)}
			{currentStep === t('onboarding.steps.activateCard') && (
				<ActivateCardStep user={user} onSuccess={goToSuccess} />
			)}
			{currentStep === t('onboarding.steps.success') && (
				<SuccessStep />
			)}
		</div>
	);
}
